import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let isLoaded = false;
let _company, _month, _year, _salesperson;
let closeWindow = true;
let isGsm = $('[name="IsGsm"]').val();

export default function (company, month, year, salespersonId) {
    _company = company;
    _month = month;
    _year = year;
    _salesperson = salespersonId;
    loadOpenProjects();
}

const setupCommentSave = function (e) {
    const that = $(this);
    const data = that.closest('form').serialize();
    $.post({
        url: `/Finance/OpenProjectSaveComment`,
        data,
        success(r) {
            if (r) {
                const $commentWindow = $('[name="commissionComments"]');
                $commentWindow.data('kendoWindow').close();
                that.closest('form').find('textarea').val('');
                showSuccessNotification('Comment added.');
            }
        }
    });
};

const setWindowData = function () {
    const $cells = $('td [data-kendoWindow]');
    const $commentWindow = $('[name="commissionComments"]');
    if ($cells.length) {
        // Unbind click events to prevent duplicate running
        $cells.unbind('click');
        // Attach Event to add Window information;
        $cells.on('click', function () {
            const $self = $(this);
            const type = $self.data('type');
            const entryId = $self.data('entry-id');
            const title = $self.data('title');
            $commentWindow.data('type', type);
            $commentWindow.data('entry-id', entryId);
            $commentWindow.data('read-only', title);
            $commentWindow.data('kendoWindow').bind('activate', function () {
                const btns = $('button.saveComment');
                btns.unbind('click');
                btns.click(setupCommentSave);
            });
        });
        // ReRun Kendo information
        $(document).trigger('on:PageUpdate');
    }
};

const openEditor = function (e) {
    const $grid = $('.grid.open-projects').data('kendoGrid');
    const selectedRow = $(e.target).closest('tr');
    $grid.editRow(selectedRow);
};

const attachEditEvent = function () {
    const $grid = $('.grid.open-projects').data('kendoGrid');
    const $openEditors = $('td [data-role="open-editor"]');
    $openEditors.unbind('click', openEditor);
    if(isGsm) {
        $openEditors.on('click', openEditor);
    }
};

function initGrid() {
    const gridElement = $('.grid.open-projects');
    const $commentWindow = $('[name="commissionComments"]');

    if (!(gridElement || gridElement.data('kendoGrid'))) return;

    const $openCommentWindow = $commentWindow.kendoWindow({
        actions: ["Close"],
        modal: true,
        scrollable: true,
        position: {top: 100, left: 100},
        visible: false
    });

    const $grid = gridElement.kendoGrid({
        dataSource: {
            autoSync: false,
            schema: {
                model: {
                    id: 'entryId',
                    fields: {
                        entryId: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        month: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        year: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        salespersonId: {
                            type: 'number',
                            editable: false
                        },
                        company: {
                            type: 'number',
                            editable: false
                        },
                        contract: {
                            type: 'string',
                            editable: false
                        },
                        contractDescription: {
                            type: 'string',
                            editable: false
                        },
                        contractBookedAmount: {
                            type: 'number',
                            editable: false
                        },
                        costBookedAmount: {
                            type: 'number',
                            editable: false
                        },
                        gpBookedAmount: {
                            type: 'number',
                            editable: false
                        },
                        gpBookedPercent: {
                            type: 'number',
                            editable: false
                        },
                        commissionPercent: {
                            type: 'number',
                            editable: true
                        },
                        commissionAmount: {
                            type: 'number',
                            editable: false
                        },
                        splitPercent: {
                            type: 'number',
                            editable: false
                        },
                        monthStart: {
                            type: 'date',
                            editable: false
                        },
                        previousCommissionPercent: {
                            type: 'number',
                            editable: true
                        },
                        commissionRateComment: {
                            type: 'string',
                            editable: true
                        },
                        hasComments: {
                            type: 'boolean',
                            editable: false,
                            default: false
                        }
                    }
                }
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'GET',
                    url: '/Finance/GetOpenProjects'
                },
                update: {
                    dataType: 'json',
                    type: 'PUT',
                    url: '/Finance/UpdateOpenProject'
                },
                parameterMap(data, type) {
                    if (type === 'read') {
                        data.company = _company;
                        data.month = _month;
                        data.year = _year;
                        data.salesperson = _salesperson;
                    }
                    if (type === 'update') {
                        const nd = {}
                        nd.entryId = data.entryId;
                        nd.commissionPercent = data.commissionPercent; // / 100.00;
                        nd.previousCommissionPercent = data.previousCommissionPercent;
                        nd.comment = data.commissionRateComment;
                        nd.gsmPin = data.PIN;
                        data = nd;
                    }
                    return data;
                }
            },
            requestEnd(e) {
                if (e.type === 'update') {
                    if ((e.response.length && e.response[0].success === false)
                        || (e.response.success !== undefined && e.response.success === false)) {
                        closeWindow = false;
                        showErrorNotification(e.response[0].reason ?? e.response.reason);
                        e.preventDefault(true);
                    } else {
                        closeWindow = true;
                        showSuccessNotification('Commission rate updated!');
                    }
                }
            }
        },
        columns: [
            {
                title: 'Job',
                field: 'contract',
                headerAttributes: {style: 'white-space: normal'},
                width: '200px',
                template(dataItem) {
                    return `${dataItem.contract} - ${dataItem.contractDescription}`;
                }
            },
            {
                title: 'Open Date',
                field: 'monthStart',
                headerAttributes: {style: 'white-space: normal'},
                width: '90px',
                template(dataItem) {
                    return `${kendo.toString(dataItem.monthStart, 'd')}`;
                }
            },
            {
                title: 'Booked Contract',
                field: 'contractBookedAmount',
                headerAttributes: {style: 'white-space: normal'},
                width: '125px',
                template(dataItem) {
                    return `${kendo.toString(dataItem.contractBookedAmount, 'c2')}`;
                }
            },
            {
                title: 'Estimated Cost',
                field: 'costBookedAmount',
                headerAttributes: {style: 'white-space: normal'},
                width: '125px',
                template(dataItem) {
                    return `${kendo.toString(dataItem.costBookedAmount, 'c2')}`;
                }
            },
            {
                title: 'GP',
                field: 'gpBookedAmount',
                headerAttributes: {style: 'white-space: normal'},
                width: '125px',
                template(dataItem) {
                    return `
                      <div>
                        <div style="width: 100%;">${kendo.toString(dataItem.gpBookedAmount, 'c2')}</div>
                        <div style="width: 100%;">${kendo.toString(dataItem.gpBookedPercent, 'p2')}</div>
                      </div>`;
                }
            },
            {
                title: 'Commission Rate',
                field: 'commissionPercent',
                headerAttributes: {style: 'white-space: normal'},
                width: '100px',
                template(dataItem) {
                    const commish = `<div data-role="open-editor" style="width: 100%;">${kendo.toString(dataItem.commissionPercent, 'p2')}</div>`;
                    if (dataItem.previousCommissionPercent == undefined || dataItem.previousCommissionPercent === dataItem.commissionPercent)
                        return commish;

                    return `
                      <div>
                        ${commish}
                        <div class="t-danger" style="width: 100%;">Orig: ${kendo.toString(dataItem.previousCommissionPercent, 'p2')}</div>
                    `;
                }
            },
            {
                title: 'Commission Amount',
                field: 'commissionAmount',
                headerAttributes: {style: 'white-space: normal'},
                width: '100px',
                template(dataItem) {
                    const commissionAmount = dataItem.commissionAmount || (dataItem.commissionPercent * dataItem.gpBookedAmount);
                    const amount = `<div style="width: 100%;">${kendo.toString(commissionAmount, 'c2')}</div>`;
                    if (dataItem.splitPercent === 1.00) return amount;
                    else return `
                      <div>
                        ${amount}
                        <div style="width: 100%;"> ${kendo.toString(dataItem.splitPercent, 'p2')}</div>
                      </div>`;
                }
            },
            {
                width: '45px',
                template(dataItem) {
                    const title = `${dataItem.contract} - ${dataItem.contractDescription} Commission Comments`;
                    return `<span class="icon ${dataItem.hasComments ? 'icon--comment-has' : 'icon--comment-add'}" data-role="openKendoWindow" data-kendoWindow="commissionComments" data-type="OpenProject" data-entry-id="${dataItem.entryId}" data-title="${title}"`;
                }
            }
        ],
        editable: {
            mode: 'popup',
            window: {
                draggable: false,
                modal: true,
                close(e) {
                    if (!e.userTriggered && !closeWindow) {
                        e.preventDefault(true);
                        return;
                    }
                    setTimeout(() => {
                        attachEditEvent();
                        $(document).trigger('on:PageUpdate');
                    });
                }
            },
            template(e) {
                e.commissionPercent *= 100;
                return $('#commissionEditor').html();
            }
        },
        dataBound(e) {
            recalculateOpenProjectTotals(e.sender._data);
            attachEditEvent();
            setWindowData();
        },
        save(e) {
            e.model.commissionPercent = e.model.commissionPercent / 100.00;
        },
        resizable: false,
        mobile: false,
        scrollable: true,
        sortable: true,
        filterable: {
            operators: {
                string: {
                    contains: 'Contains',
                    startswith: 'Starts with'
                }
            }
        },
        pageable: {
            alwaysVisible: false,
            pageSizes: true,
            buttonCount: 20
        },
        noRecords: {
            template: "There are no open project commissions."
        }
    });
}

function loadOpenProjects() {
    $('.js-ssr-commissions-open-projects')
        .load('/Finance/OpenProjects',
            callback => {
                initGrid();
                isLoaded = true;
            });
}

function recalculateOpenProjectTotals(openProjects) {
    let openProjectTotals = 0;
    $.each(openProjects, function (index, op) {
        openProjectTotals += op.commissionAmount;
    })

    $('.js-new-projects-amount').val(openProjectTotals);
    $('.js-new-projects-amount-text').text(kendo.format('{0:C2}', openProjectTotals));
    updateSidebarTotals();
}

function updateSidebarTotals() {
    // Calculate Current Commission Totals
    const newProjectsAmount = Number($('.js-new-projects-amount').val()) || 0;
    const projectsUnderAmount = Number($('.js-projects-under-amount').val()) || 0;
    const projectsOverAmount = Number($('.js-projects-over-amount').val()) || 0;
    const manualAmount = Number($('.js-manual-amount').val()) || 0;
    const adjustPreviousAmount = Number($('.js-adjust-previous-amount').val()) || 0;
    const newMaintenanceAmount = Number($('.js-new-maint-amount').val()) || 0;
    const fixedPriceAmount = Number($('.js-fixed-price-amount').val()) || 0;
    const commissionsTotal = newProjectsAmount + projectsUnderAmount + projectsOverAmount + manualAmount + adjustPreviousAmount + newMaintenanceAmount + fixedPriceAmount;

    $('.js-commission-total').val(commissionsTotal);
    $('.js-commission-total-text').text(kendo.format('{0:C2}', commissionsTotal));
}